import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import "../styles.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Switch from "@material-ui/core/Switch";

function Organization({
  organizationJSON,
  buyerCollection,
  supplierCollection,
  errorMessage,
  onChange = () => {},
  onRoleChange,
}) {
  console.log(buyerCollection);
  return (
    <div className="container-fluid _createcard ">
      <div className="row _createorganization ">
        <div className="col-6">
          <TextField
            label="Organization Code *"
            id="outlined-size-normal"
            defaultValue=""
            size="small"
            fullWidth
            value={organizationJSON?.OrgCode}
            onChange={(e) => {
              onChange(e.target.value, "OrgCode", "Org");
            }}
          />

          {errorMessage.map((i) => {
            if (
              i.fieldName === "Organization Code" &&
              !organizationJSON?.OrgCode
            ) {
              return <FormHelperText>{i.error}</FormHelperText>;
            }
          })}
        </div>
        <div className="col-6">
          <TextField
            label="CW1 Mapped Organization Code *"
            id="outlined-size-normal"
            defaultValue=""
            size="small"
            fullWidth
            value={organizationJSON?.MapppedOrgCode}
            onChange={(e) => {
              onChange(e.target.value, "MapppedOrgCode", "Org");
            }}
          />
          {errorMessage.map((i) => {
            if (
              i.fieldName === "Mapped Organization Code" &&
              !organizationJSON?.MapppedOrgCode
            ) {
              return <FormHelperText>{i.error}</FormHelperText>;
            }
          })}
        </div>
      </div>

      <div className="row _createorganization ">
        <div className="col-6">
          <TextField
            label="Organization Name *"
            id="outlined-size-normal"
            defaultValue=""
            size="small"
            fullWidth
            value={organizationJSON?.OrgName}
            onChange={(e) => {
              onChange(e.target.value, "OrgName", "Org");
            }}
          />
          {errorMessage.map((i) => {
            if (
              i.fieldName === "Organiation Name" &&
              !organizationJSON?.OrgName
            ) {
              return <FormHelperText>{i.error}</FormHelperText>;
            }
          })}
        </div>
        <div className="col-6">
          <TextField
            label="CW1 Mapped Organization Name *"
            id="outlined-size-normal"
            defaultValue=""
            size="small"
            fullWidth
            value={organizationJSON?.MapppedOrgName}
            onChange={(e) => {
              onChange(e.target.value, "MapppedOrgName", "Org");
            }}
          />
          {errorMessage.map((i) => {
            if (
              i.fieldName === "Mapped organiation Name" &&
              !organizationJSON?.MapppedOrgName
            ) {
              return <FormHelperText>{i.error}</FormHelperText>;
            }
          })}
        </div>
      </div>

      <div className="row _createorganization ">
        <div className="col-12" style={{ display: "flex" }}>
          <FormControl>
            <FormLabel id="demo-radio-buttons-group-label">
              <h5>User Role *</h5>
            </FormLabel>
            <div className="d-flex">
              <RadioGroup value={organizationJSON?.IsConsignee}>
                <FormControlLabel
                  value="Consignee"
                  control={
                    <Radio
                      onClick={(e) => {
                        onRoleChange(e.target.value, "IsConsignee", "Org");
                      }}
                      checked={organizationJSON?.IsConsignee}
                    />
                  }
                  label="Consignee"
                />
              </RadioGroup>
              <RadioGroup value={organizationJSON?.IsConsignor}>
                <FormControlLabel
                  value="Consignor"
                  control={
                    <Radio
                      checked={organizationJSON?.IsConsignor}
                      onClick={(e) => {
                        onRoleChange(e.target.value, "IsConsignor", "Org");
                      }}
                    />
                  }
                  label="Consignor"
                />
              </RadioGroup>
              <RadioGroup value={organizationJSON?.IsForwarder}>
                <FormControlLabel
                  value="Forwarder"
                  control={
                    <Radio
                      checked={organizationJSON?.IsForwarder}
                      onClick={(e) => {
                        onRoleChange(e.target.value, "IsForwarder", "Org");
                      }}
                    />
                  }
                  label="Forwarder"
                />
              </RadioGroup>
            </div>
            {errorMessage.map((i) => {
              if (
                i.fieldName === "User Role" &&
                !(
                  organizationJSON?.IsConsignee ||
                  organizationJSON?.IsConsignor ||
                  organizationJSON?.IsForwarder
                )
              ) {
                return <FormHelperText>{i.error}</FormHelperText>;
              }
            })}

            <div className="mt-3">
              {organizationJSON?.IsConsignee ||
              organizationJSON?.IsForwarder ? (
                <div>
                  <FormLabel id="demo-radio-buttons-group-label mb-2">
                    <h5>Buyer</h5>
                  </FormLabel>
                  <div className="container-fluid supplier_role">
                    <div className="row">
                      <div className="col-6">
                        <TextField
                          label="Buyer Code *"
                          id="outlined-size-normal"
                          defaultValue=""
                          size="small"
                          fullWidth
                          value={buyerCollection[0]?.BuyerCode}
                          onChange={(e) => {
                            onChange(e.target.value, "BuyerCode", "Buy");
                          }}
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          label="Buyer Name *"
                          id="outlined-size-normal"
                          defaultValue=""
                          size="small"
                          fullWidth
                          value={buyerCollection[0]?.BuyerName}
                          onChange={(e) => {
                            onChange(e.target.value, "BuyerName", "Buy");
                          }}
                        />
                      </div>
                      {/* <Switch
                        checked={buyerCollection[0]?.isBuyer}
                        onChange={(e) => {
                          onChange(e.target.checked, "isBuyer", "Buy");
                        }}
                        color="primary"
                      /> */}
                    </div>
                  </div>
                </div>
              ) : null}

              {organizationJSON?.IsConsignor && (
                <div>
                  <FormLabel id="demo-radio-buttons-group-label p-3">
                    <h5>Supplier</h5>
                  </FormLabel>
                  <div className="container-fluid supplier_role ">
                    <div className="row">
                      <div className="col-6">
                        <TextField
                          label="Supplier Code *"
                          id="outlined-size-normal"
                          defaultValue=""
                          size="small"
                          fullWidth
                          value={supplierCollection[0]?.SupplierCode}
                          onChange={(e) => {
                            onChange(e.target.value, "SupplierCode", "Sup");
                          }}
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          label="Supplier Name *"
                          id="outlined-size-normal"
                          defaultValue=""
                          size="small"
                          fullWidth
                          value={supplierCollection[0]?.SupplierName}
                          onChange={(e) => {
                            onChange(e.target.value, "SupplierName", "Sup");
                          }}
                        />
                      </div>
                      {/* <Switch
                        checked={buyerCollection[0]?.isSupplier}
                        onChange={(e) => {
                          onChange(e.target.checked, "isSupplier", "Buy");
                        }}
                        color="primary"
                      /> */}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </FormControl>
        </div>
      </div>
    </div>
  );
}

export default Organization;
